import Phaser from 'phaser';

export class HatShadow {
  scene: Phaser.Scene;
  graphics: Phaser.GameObjects.Graphics;

  private static readonly RX: number = 70;
  private static readonly RY: number = 18;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.graphics = scene.add.graphics();
    this.graphics.setDepth(5);
    this.draw(1);
    this.graphics.setVisible(false);
  }

  private draw(scale: number) {
    this.graphics.clear();
    this.graphics.fillStyle(0x000000, 1);
    this.graphics.fillEllipse(0, 0, HatShadow.RX * 2 * scale, HatShadow.RY * 2 * scale);
  }

  update(screenX: number, screenY: number, scale: number, alpha: number) {
    this.draw(scale);
    this.graphics.setPosition(screenX, screenY);
    this.graphics.setAlpha(alpha);
  }

  setVisible(visible: boolean) {
    this.graphics.setVisible(visible);
  }
}
